import Icon from "@components/Icon";
import { colours, device } from "@helpers";
import { mixpanelTrack } from "@helpers/mixpanel.helper";
import Link from "next/link";
import { usePathname } from "next/navigation";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import NavbarSubMenu from "./NavbarSubMenu";

const DIV = styled.div`
  color: ${colours.MIDNIGHT_BLUE};
  display: flex;
  height: 100px;
  align-items: center;

  position: relative;

	margin: 0 clamp(0px, 2.2vw, 28px);


  
`;

const AccordionButton = styled.button`
  background: transparent;
  border: none;
  width: inherit;
  padding: 0px;
  margin-left: 2px;
  display: flex;
  align-items: center;
  min-width: 24px;
  min-height: 24px;

    &:hover {
    border: none !important;
    border-bottom: none;
    outline: none;
    text-decoration: none;
  	}

	&:focus {
	border: ${({ activeStyle }) =>
		activeStyle ? "1px solid white" : `2px solid ${colours.MIDNIGHT_BLUE}`};
	}
  
`;

const SPAN = styled.span`
  align-items: center;
  display: flex;
`;

const Links = styled.span`
  & > * {
    text-decoration: none;
    font-size: 18px;
    z-index: 100;
    
    &:hover {
    border-bottom: ${({ activeStyle }) =>
			activeStyle ? "1px solid white" : `1px solid ${colours.MIDNIGHT_BLUE}`};
  }
  }
  text-decoration: ${({ activeStyle }) =>
		activeStyle ? "underline" : "inherit"};
`;

const iconSizes = {
	iconTablet: 18,
	iconLaptop: 18,
	iconDesktop: 20,
	iconDesktopLarge: 22,
};

const NavListItem = ({
	navInfo,
	setShowMainDropdown,
	activeStyle,
	ctaUrl = "",
}) => {
	const [isShown, setIsShown] = useState();
	const pathname = usePathname();

	useEffect(() => {
		if (!isShown) return;

		const handleKeyDown = (e) => {
			if (e.key === "Escape") {
				setIsShown(false);
			}
		};
		document.addEventListener("keydown", handleKeyDown);
		return () => document.removeEventListener("keydown", handleKeyDown);
	}, [isShown]);

	return (
		<DIV
			onMouseLeave={() => setIsShown(false)}
			onMouseEnter={() => navInfo.subNav && setShowMainDropdown(false)}
		>
			<SPAN>
				<Links
					// activeStyle={activeStyle || pathname === navInfo.link}
					isShown={isShown}
					setBorderBottom={navInfo.subNav && isShown}
					activeStyle={activeStyle}
				>
					{!pathname.includes("help") ? (
						<Link
							onClick={() => {
								mixpanelTrack("header_hypelink_clicked", {
									cta_location: pathname,
									cta_name: navInfo.name,
								});
								setIsShown(false);
							}}
							
							onMouseEnter={() => setIsShown(true)}
							href={navInfo.link}
						>
							{navInfo.name}
						</Link>
					) : (
						<a
							onClick={() => {
								mixpanelTrack("need_help_clicked", {
									page_name: ctaUrl,
								});
								setIsShown(false);
							}}
							onMouseEnter={() => setIsShown(true)}
							href={navInfo.link}
						>
							{navInfo.name}
						</a>
					)}
				</Links>
				{navInfo.subNav && (
					<AccordionButton
						onClick={() => setIsShown(!isShown)}
						aria-label="open submenu"
					>
						<Icon iconName="chevron-down" iconSizes={iconSizes} alt="" />
					</AccordionButton>
				)}
			</SPAN>
			{navInfo.subNav && (
				<NavbarSubMenu
					navInfo={navInfo}
					isShown={isShown}
					setIsShown={setIsShown}
				/>
			)}
		</DIV>
	);
};

export default NavListItem;
